import A2PRegistrationWarning, {
  A2PReminderStatus,
} from 'shared-assets/components/A2PRegistrationWarning';

angular
  .module('kareo.ui.shared.directives.a2p-registration-warning', ['react'])
  .directive('a2pRegistrationWarning', [
    'reactDirective',
    reactDirective => reactDirective(A2PRegistrationWarning, {}),
  ])
  .directive('a2pReminderStatus', [
    'reactDirective',
    reactDirective => reactDirective(A2PReminderStatus, { enabled: '=' }),
  ]);
